import { Typography, Divider } from 'antd';

const { Title, Text, Paragraph, Link } = Typography;

const section = (num, heading, children) => (
  <>
    <Title level={4} style={{ marginTop: 28, marginBottom: 8 }}>
      {num}. {heading}
    </Title>
    {children}
  </>
);

const InventoryPrivacyPolicy = () => (
  <div
    style={{
      minHeight: '100vh',
      background: '#f8f6f0',
      display: 'flex',
      justifyContent: 'center',
      padding: 'clamp(24px, 5vw, 60px) clamp(16px, 5vw, 40px)',
    }}
  >
    <div
      style={{
        maxWidth: 760,
        width: '100%',
        background: '#fff',
        borderRadius: 10,
        padding: 'clamp(24px, 5vw, 48px)',
        boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
      }}
    >
      {/* Header */}
      <Title
        level={2}
        style={{
          color: '#fca600',
          fontFamily: 'Mont, sans-serif',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          marginBottom: 4,
        }}
      >
        Privacy Policy
      </Title>
      <Title level={4} style={{ fontWeight: 'normal', marginTop: 0, color: '#555' }}>
        Festivals Inventory Management
      </Title>
      <Text type="secondary">Last updated: May 6, 2026</Text>

      <Divider />

      {section(1, 'Overview',
        <Paragraph>
          Festivals Inventory Management ("the App") is an internal inventory management tool
          operated by Festivals Portal (<Link href="https://portal.festivalsportal.mt" target="_blank" rel="noopener noreferrer">festivalsportal.mt</Link>).
          This policy explains what data the App accesses and how it is used.
        </Paragraph>
      )}

      {section(2, 'Data We Collect', <>
        <Title level={5} style={{ marginBottom: 4, marginTop: 16 }}>API Token</Title>
        <Paragraph>
          The App requires a scanner authentication token to communicate with the Festivals Portal API.
          This token is entered manually by the operator and stored locally on the device using
          Android's SharedPreferences storage. It is never shared with third parties.
        </Paragraph>

        <Title level={5} style={{ marginBottom: 4, marginTop: 16 }}>Barcode Scans</Title>
        <Paragraph>
          When a barcode is scanned, the barcode value is sent to the Festivals Portal API
          to retrieve inventory item details and submit stock transactions. Scan data is used
          solely for inventory management purposes.
        </Paragraph>

        <Title level={5} style={{ marginBottom: 4, marginTop: 16 }}>Network Requests</Title>
        <Paragraph>
          The App communicates exclusively with the Festivals Portal API. All requests are made over HTTPS.
          No data is sent to any analytics, advertising, or third-party service.
        </Paragraph>
      </>)}

      {section(3, 'Data We Do Not Collect',
        <>
          <Paragraph>The App does not collect:</Paragraph>
          <ul style={{ paddingLeft: 24, lineHeight: 2 }}>
            <li>Personal information (name, email, phone number)</li>
            <li>Location data</li>
            <li>Camera or microphone data</li>
            <li>Device identifiers</li>
            <li>Usage analytics or crash reports sent to third parties</li>
          </ul>
        </>
      )}

      {section(4, 'Data Storage',
        <Paragraph>
          All data stored by the App (the API token) is kept locally on the device and is not
          backed up to external services. Uninstalling the App removes all locally stored data.
        </Paragraph>
      )}

      {section(5, 'Data Sharing',
        <Paragraph>
          We do not sell, trade, or transfer any data to third parties. The only external
          communication is with our backend service, operated by
          the same organisation.
        </Paragraph>
      )}

      {section(6, 'Access Control',
        <Paragraph>
          This App is intended for authorised staff only. Access is controlled via the scanner
          token. If a token is compromised, it must be revoked via the Festivals Portal backend.
        </Paragraph>
      )}

      {section(7, "Children's Privacy",
        <Paragraph>
          This App is not directed at individuals under the age of 18 and is intended solely
          for use by authorised employees and contractors.
        </Paragraph>
      )}

      {section(8, 'Changes to This Policy',
        <Paragraph>
          We may update this policy from time to time. Any changes will be posted at the URL
          where this policy is hosted. Continued use of the App after changes constitutes
          acceptance of the updated policy.
        </Paragraph>
      )}

      {section(9, 'Contact',
        <>
          <Paragraph>
            If you have questions about this privacy policy, contact:
          </Paragraph>
          <Paragraph>
            <Text strong>portal.fm@festivals.mt</Text>
            <br />
            <Link href="https://portal.festivalsportal.mt" target="_blank" rel="noopener noreferrer">
              Festivals Portal
            </Link>
          </Paragraph>
        </>
      )}

      <Divider />
      <Text type="secondary" style={{ fontSize: 12 }}>
        &copy; {new Date().getFullYear()} Festivals Portal. All rights reserved.
      </Text>
    </div>
  </div>
);

export default InventoryPrivacyPolicy;
